import React from "react";
import { FiGrid } from "react-icons/fi";
import { Link } from "react-router-dom";
import { BRAND_ROUTE } from "../../routes/constant";

const BrandGrid = ({ brands,  categorySlug, isDarkMode, onClose }) => {
  if (!brands || brands.length === 0) return null;

  return (
    <div className="p-2">
      <div className="flex flex-col gap-0.5 max-h-[280px] overflow-y-auto custom-scrollbar pr-1">
        {brands.map((brand) => (
          <Link
            key={brand.id}
            to={BRAND_ROUTE(categorySlug, brand.slug)}
            className={`
              flex items-center gap-2 px-2 py-1.5 rounded-md transition-colors
              ${
                isDarkMode
                  ? "hover:bg-gray-700 text-gray-200"
                  : "hover:bg-gray-100 text-gray-700"
              }
            `}
            onClick={onClose}
          >
            {brand.image ? (
              <img
                src={brand.image}
                alt={brand.name}
                className="object-contain w-4 h-4"
                style={{ filter: isDarkMode ? "brightness(0.9)" : "none" }}
              />
            ) : (
              <FiGrid
                className={`w-4 h-4 ${isDarkMode ? "text-gray-500" : "text-gray-400"}`}
              />
            )}
            <span
              className={`text-xs ${isDarkMode ? "text-gray-200" : "text-gray-700"}`}
            >
              {brand.name}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BrandGrid;
